export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
      },
      "fr": {
        "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déconnexion"])}
      }
    }
  })
}
